module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-13.7d71375c.png";